export default {
  computed: {
    // 判断浏览器是否支持 PWA 安装 API
    isPwaSupported() {
      // 检查Service Worker支持
      if (!('serviceWorker' in navigator)) {
        return false;
      }

      // 检查Promise支持（Service Worker需要）
      if (!window.Promise) {
        return false;
      }

      // 检查Fetch API支持
      if (!('fetch' in window)) {
        return false;
      }

      // 检查Cache API支持
      if (!('caches' in window)) {
        return false;
      }

      // 检查Manifest相关API
      if (!('onbeforeinstallprompt' in window)) {
        return false;
      }

      return true;
    }
  },
  methods: {
    shouldShowPwaTips() {
      if (window.deferredPrompt) {
        return false;
      }
      return true;
    }
  }
};
